var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"submit-button",class:[_vm.design !== '' ? 'submit-button--' + _vm.design : ''],attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click')}}},[_c('span',{staticClass:"submit-button__text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ab02e70","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/partials/SubmitButton.vue
// module id = null
// module chunks = 